import * as PropTypes from 'prop-types'

export class Flickity extends Component {

  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    selectedIndex: PropTypes.number,
    options: PropTypes.object,
    onSelect: PropTypes.func
  }

  state = {
    mounted: false
  }

  render () {
    return this.state.mounted && (
      <div ref={el => { this.el = el }} className={this.props.className}>
        {this.props.children}
      </div>
    )
  }

  componentDidMount () {
    this.setState({ mounted: true })
    this.loadingFlickity = import('flickity')
  }

  componentWillReceiveProps ({ selectedIndex }) {
    if (selectedIndex !== this.props.selectedIndex) {
      this.flickity && this.flickity.select(selectedIndex)
    }
  }

  componentWillUpdate () {
    this.destroyFlickity()
  }

  componentWillUnmount () {
    this.destroyFlickity()
  }

  componentDidUpdate () {
    this.enableFlickity()
  }

  shouldComponentUpdate ({ children }, { mounted }) {
    return mounted !== this.state.mounted
  }

  enableFlickity () {
    const { el } = this
    this.loadingFlickity.then(({ default: Flickity }) => {
      this.destroyFlickity()
      if (el && el === this.el) {
        this.flickity = new Flickity(el, this.props.options)
        this.flickity.on('select', this.handleFlickitySelect)
      }
    })
  }

  handleFlickitySelect = () => this.props.onSelect && this.props.onSelect(this.flickity.selectedIndex)

  destroyFlickity () {
    if (!this.flickity) return
    this.flickity.off('select', this.handleFlickitySelect)
    this.flickity.destroy()
    this.flickity = null
  }
}
